class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this._cookieName = 'pm_recently_viewed';
    this._cookieExpiry = 24 * 60 * 60;
    this._maxItems = 8;

    this.recentlyViewed = [];
    this.swiper = this.querySelector('swiper-container').swiper;
  }

  connectedCallback() {
    this._getCookie();

    if ( Shopify.productHandle !== undefined ) {
      // Add current product
      this.add(Shopify.productHandle);

      // Exclude current product
      this.recentlyViewed = this.recentlyViewed.filter((productHandle) => productHandle != Shopify.productHandle );
    }

    if ( !this.recentlyViewed.length ) {
      this.destroy();
      return;
    }

    this.render();

  }

  _getCookie() {
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].split("=");
            if (this._cookieName == cookie[0].trim()) {
              let handles = decodeURIComponent(cookie[1]);
              this.recentlyViewed = handles.split(',');
            }
        }
    }
  
    _setCookie() {
        let handles = this.recentlyViewed.slice(0,this._maxItems),
            value = handles.join(','),
            cookie = this._cookieName + "=" + encodeURIComponent(value) + ";max-age=" + this._cookieExpiry + ";path=/";
        document.cookie = cookie;
    }

    add(handle) {
        if (this.recentlyViewed.indexOf(handle) === -1) {
            this.recentlyViewed.push(handle);
            this._setCookie();
        }
    }

    remove(handle) {
        let index = this.recentlyViewed.indexOf(handle);
        if (index !== -1) {
            this.recentlyViewed.splice(index, 1);
            this._setCookie()
        }
    }

    get() {
        return this.recentlyViewed.reverse();
    }

    destroy() {
        this.closest('section').remove();
    }

    render() {

      const _this = this;
      this.recentlyViewed.forEach(function(handle, index) {
          let url = '/products/' + handle + '?view=card';
          fetch(url).then(function(response) {
              if ( response.ok ) {
                return response.text();
              } else {
                _this.remove(handle);
                return false;
              }
            })
            .then(function(html) {
              var $doc = new DOMParser().parseFromString(html, "text/html"),
                $slide = document.createElement('swiper-slide'),
                $tile = $doc.querySelector('div');

              loadColours($tile);
              
              $slide.append($tile)
              _this.swiper.addSlide(index, $slide);
            })
            .catch(error => {
              console.warn("Could not find product:", url);
            })
      });

      this.swiper.init();
    }

}
customElements.define('recently-viewed-products', RecentlyViewedProducts);